module.exports = __webpack_public_path__ + "img/Path28521.3dee4fa4.png";